<template>
	<popper v-bind="$attrs">
		<template #handle>
			<div @click="setDirty" @hover="setDirty">
				<slot name="handle"></slot>
			</div>
		</template>

		<template #title>
			<slot name="title"></slot>
		</template>

		<template #content>
			<div v-if="isDirty">
				<slot name="content"></slot>
			</div>
		</template>
	</popper>
</template>

<script>

export default {
    name: "custom-tooltip",

	data: function() {
		return {
			isDirty: false
		};
	},

	mounted() {
		if(this.$attrs.trigger !== undefined) {
			this.isDirty = this.$attrs.trigger === "preview";
		}
	},

	methods: {
		setDirty() {
			this.isDirty = true;
		}
	}
};
</script>